import createDOMPurify from 'dompurify';
import { NOTE_FORBID_TAGS, NOTE_HTML_ALLOWED_ATTR, NOTE_HTML_ALLOWED_TAGS, } from './htmlContract.js';
const DOMPurify = createDOMPurify(window);
export function sanitizeNoteHtml(html) {
    if (!html)
        return '';
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [...NOTE_HTML_ALLOWED_TAGS],
        ALLOWED_ATTR: [...NOTE_HTML_ALLOWED_ATTR],
        FORBID_TAGS: [...NOTE_FORBID_TAGS],
        ALLOW_UNKNOWN_PROTOCOLS: false,
    });
}
